// Introducing the method of registering components
import { withInstall } from '@/utils';
// Introducing Components
import PullRefresh from './pullRefresh.vue';
// Throw component
export const AmzPullRefresh = withInstall(PullRefresh, 'AmzPullRefresh');
